import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">焦点专题</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">重磅推荐 · 精选擦边内容专题合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="inline-block text-xs px-2 py-0.5 bg-primary-500 text-white rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-white mb-1">{item.title}</h3>
                <p className="text-xs text-white/80 hidden sm:block">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}